import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface DataListCardRowProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

/**
 * One row in the mobile stacked list inside TableCard (divide-y on parent).
 * Matches TableRow hover affordance when clickable.
 */
export function DataListCardRow({
  children,
  className,
  onClick,
}: DataListCardRowProps): JSX.Element {
  return (
    <div
      role={onClick != null ? "button" : undefined}
      tabIndex={onClick != null ? 0 : undefined}
      className={cn(
        "p-3 transition-colors duration-150 motion-reduce:transition-none md:p-4",
        onClick != null &&
          "cursor-pointer hover:bg-muted/50 dark:hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        className
      )}
      onClick={onClick}
      onKeyDown={
        onClick != null
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      {children}
    </div>
  );
}
